import $ from "jquery";

// Header scroll based classes

const el = $(".header-sticky");
const elHeight = el.outerHeight();
let scrollTop = $(window).scrollTop();
let lastScrollTop = 0;

if (scrollTop > 0) {
  el.addClass("header-scrolled-pos");
} else {
  el.addClass("header-initial-pos");
}

$(window).on("scroll", function (event) {
  let scrollTop = $(this).scrollTop();

  if (scrollTop > 0) {
    el.removeClass("header-initial-pos").addClass("header-scrolled-pos");
  } else {
    el.removeClass("header-scrolled-pos").addClass("header-initial-pos");
  }

  /*
	if ( scrollTop > elHeight ) {
		if ( scrollTop > lastScrollTop ) {
			$( 'body' ).removeClass( 'scroll-up' ).addClass( 'scroll-down' );
		} else {
			$( 'body' ).removeClass( 'scroll-down' ).addClass( 'scroll-up' );
		}
	}
  */

  lastScrollTop = scrollTop;
});

document.addEventListener("DOMContentLoaded", function () {
  const header = document.querySelector(".header");
  const hero = document.querySelector(".hero");
  const targetNode = document.body;

  // Function to move script and iframe elements
  const moveElements = () => {
    const elements = document.querySelectorAll(
      ".header ~ script, .header ~ noscript, .header ~ iframe"
    );
    elements.forEach((element) => {
      if (
        header.compareDocumentPosition(element) &
          Node.DOCUMENT_POSITION_FOLLOWING &&
        hero.compareDocumentPosition(element) & Node.DOCUMENT_POSITION_PRECEDING
      ) {
        document.body.insertBefore(element, document.body.firstChild);
      }
    });
  };

  // Initial check in case elements are already present
  moveElements();

  // Create an observer instance linked to the callback function
  const observer = new MutationObserver((mutationsList) => {
    for (let mutation of mutationsList) {
      if (mutation.type === "childList") {
        moveElements();
      }
    }
  });

  // Start observing the body for added nodes
  observer.observe(targetNode, { childList: true, subtree: true });
});
